module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "widgets",
    attrs: {
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.widgetTitle))]), _vm._v(" "), _c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Click on the different coloured segments to view the corresponding data in your quote report.")])]), _vm._v(" "), _c('GChart', {
    ref: "gChart",
    attrs: {
      "type": "BarChart",
      "data": _vm.graphData,
      "resizeDebounce": 500,
      "events": _vm.chartEvents,
      "options": _vm.chartOptions
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('dialog-filter-config', {
    attrs: {
      "fc-key": "quote_val_per_rep",
      "widget-title": _vm.widgetTitle
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}